/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAuthVerify200Response
 */
export interface GetAuthVerify200Response {
    /**
     * 
     * @type {string}
     * @memberof GetAuthVerify200Response
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof GetAuthVerify200Response
     */
    userId: string;
}

/**
 * Check if a given object implements the GetAuthVerify200Response interface.
 */
export function instanceOfGetAuthVerify200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function GetAuthVerify200ResponseFromJSON(json: any): GetAuthVerify200Response {
    return GetAuthVerify200ResponseFromJSONTyped(json, false);
}

export function GetAuthVerify200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAuthVerify200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'userId': json['userId'],
    };
}

export function GetAuthVerify200ResponseToJSON(value?: GetAuthVerify200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'userId': value.userId,
    };
}

